import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

import Head from "../../components/Head/Head";
import NavBar from "../NavBar/NavBar";
import ContactUs from "../Forms/ContactUs/ContactUs";
import Footer from "../Footer/Footer";
import Prefer from "../Prefer/Prefer";
import Offices from "../Offices/Offices";
import InstantQuote from "../InstantQuote/InstantQuote";

import HeroImg from "../../images/template-hero.png";
import HeroBanner from "../../images/template-hero.jpg";

import ServicesContents from "../../data/content/services";
import LanguagesContents from "../../data/content/language";

import "./Template.css";

const Template = ({ language, service }) => {
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const type = language ? language.type : service.type;
  const content = language ? LanguagesContents : ServicesContents;

  useEffect(() => {
    if (!content[type]) return false;
    else setOpen(true);
  }, [history, type, content]);

  return (
    <>
      {open && (
        <div className="template position-relative">
          <Head
            title={`${content[type].introduction.head} at your tips`}
            description={`We provide ${content[type].introduction.head} anywhere in the world.`}
            keywords={`translation, interpretation, certified, services, language, conference interpreter, document, localization, translators, interpreter, translator, translation company, translation services, translation companies, translation agencies, document translation, translation services near me, translate document, document translation service, document translation services online, simultaneous interpretation services, multilingual services, sworn translators, certified translations`}
          />
          <NavBar />
          <div className="template__hero container overflow-hidden d-flex f-50 align-center justify-between position-relative z-1">
            <div className="f-50 my-40">
              <div className="d-flex flex-column align-start justify-center">
                <h2 className="font-heading text-capitalise">
                  Professional {type.split("-").join(" ")} at Your Finger Tips
                </h2>
                <p className="font-bigger mt-40">
                  We provide {type.split("-").join(" ")} at the most
                  professional level bearing client specifics and interest at
                  the core of our services.
                </p>
                <a
                  href="/quote"
                  className="template__link mt-40 py-10 px-20 font-bold"
                >
                  REQUEST A QUOTE
                </a>
              </div>
            </div>
            <div className="d-flex flex-row-reverse justify-end overflow-hidden f-50">
              <img className="d-flex" src={HeroImg} alt="" />
            </div>
          </div>
          <img className="template__banner my-20" src={HeroBanner} alt="" />
          <div className="template__sec1 container d-flex flex-column align-center justify-between">
            <div className="">
              <h2 className="font-heading">
                {content[type].introduction.head}
              </h2>
              <p className="my-40 lh-lg font-heavy">
                {content[type].introduction.p}
              </p>
              <a
                href="/quote"
                className="template__link my-40 py-10 px-20 font-bold"
              >
                REQUEST A QUOTE
              </a>
            </div>
          </div>
          {content[type].links.length > 0 && (
            <div className="template__sec2 container">
              <h2 className="font-heading py-40 text-center mx-auto">
                We provide various {type.split("-").join(" ")} Services right at
                your Finger Tips
              </h2>
              <div className="py-40">
                <ul className="grid c-5 gap-20 list-none mb-40">
                  {content[type].links.map((link, i) => (
                    <li
                      className="border-1 py-20 px-10 text-left"
                      key={link.concat(i)}
                    >
                      • {link}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
          {content[type].points.map((point, i) => (
            <div
              key={point.head.concat(i)}
              className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100"
            >
              <div className="f-50">
                <div>
                  <h2 className="font-heading py-40">{point.head}</h2>
                  <p className="lh-lg font-heavy">{point.p}</p>
                </div>
              </div>
            </div>
          ))}
          {content[type].conclusion.head !== "" && (
            <div className="template__sec4 container d-flex flex-column align-center justify-between">
              <div className="">
                <h2 className="font-heading">
                  {content[type].conclusion.head}
                </h2>
                <p className="my-40 lh-lg font-heavy">
                  {content[type].conclusion.p}
                </p>
              </div>
            </div>
          )}
          <Prefer />
          <Offices />
          <ContactUs />
          <div className="container">
            <InstantQuote />
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};

export default Template;
